import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { Divider } from "../../../Divider/Divider";
import Modal from "../../../Modal/Modal";
import Scrollbar from "../../../Scrollbar/Scrollbar";
import Search from "../../../Search/Search";
import { defaultPropArray } from "../../../constants";
import { ClickOutside } from "../../ClickOutside";
import { DropListItem } from "../components/DropListItem";
import { ListItem, ListRoot } from "../../List";
import { TextBase } from "../../TextBase";
import { keyCode } from "../../../utils/keyCodes";
import noop from "../../../utils/noop";
import { isKeyboardEvent, isSelected } from '../helpers';
import styles from './DropListMobile.css';
var cx = classNames.bind(styles);
export var DropListMobile = /*#__PURE__*/forwardRef(function DropListMobile(_ref, ref) {
  var scrollable = _ref.scrollable,
      _ref$maxVisibleItems = _ref.maxVisibleItems,
      maxVisibleItems = _ref$maxVisibleItems === void 0 ? 3 : _ref$maxVisibleItems,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? defaultPropArray : _ref$items,
      icon = _ref.icon,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? defaultPropArray : _ref$selected,
      multiple = _ref.multiple,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      onSelect = _ref.onSelect,
      searchable = _ref.searchable,
      title = _ref.title,
      opened = _ref.opened,
      confirmLabel = _ref.confirmLabel,
      onSearch = _ref.onSearch,
      onClickOutside = _ref.onClickOutside,
      noOptionsMessage = _ref.noOptionsMessage,
      _ref$hasSubItems = _ref.hasSubItems,
      hasSubItems = _ref$hasSubItems === void 0 ? defaultPropArray : _ref$hasSubItems,
      defaultOptionItem = _ref.defaultOptionItem,
      defaultOptionOnClick = _ref.defaultOptionOnClick,
      isSorting = _ref.isSorting,
      locale = _ref.locale;

  var handleSelect = function handleSelect(item) {
    return function () {
      if (!item.disabled && onSelect) {
        onSelect(item);
      }
    };
  };

  var handleKeyPress = function handleKeyPress(item) {
    return function (e) {
      if (isKeyboardEvent(e)) {
        if (e.keyCode === keyCode.ENTER) {
          handleSelect(item)();
        }
      }
    };
  };

  return /*#__PURE__*/React.createElement(Modal, {
    id: "DS_DropList_Popup",
    theme: theme,
    isOpen: opened,
    mobilePosition: "bottom",
    title: title,
    withScroll: false,
    onConfirm: multiple ? noop : undefined,
    onClose: noop,
    topDivider: true,
    confirmLabel: confirmLabel,
    withoutTopDividerGap: true
  }, /*#__PURE__*/React.createElement(ClickOutside, {
    onClickOutside: onClickOutside
  }, searchable && /*#__PURE__*/React.createElement("div", {
    className: cx('search')
  }, /*#__PURE__*/React.createElement(Search, {
    onChange: onSearch,
    theme: "grey",
    size: "small",
    locale: locale
  })), /*#__PURE__*/React.createElement(Scrollbar, {
    withoutScrollBar: !scrollable,
    maxHeight: maxVisibleItems * 56
  }, /*#__PURE__*/React.createElement(ListRoot, {
    ref: ref,
    classes: {
      root: cx('list', "theme_".concat(theme))
    },
    tabIndex: -1,
    role: "listbox"
  }, isSorting && defaultOptionItem && /*#__PURE__*/React.createElement(DropListItem, {
    item: defaultOptionItem,
    isSelected: isSelected(selected, defaultOptionItem),
    multiple: multiple,
    theme: theme,
    onClick: defaultOptionOnClick,
    onKeyDown: defaultOptionOnClick,
    onChange: defaultOptionOnClick
  }), items.length ? items.map(function (item) {
    return /*#__PURE__*/React.createElement(DropListItem, {
      key: item.value,
      as: item.as,
      item: item,
      isSelected: isSelected(selected, item),
      icon: item.icon || icon,
      onClick: handleSelect(item),
      onKeyDown: handleKeyPress(item),
      classes: {
        mobileCheckIcon: cx('icon_check')
      }
    });
  }) : /*#__PURE__*/React.createElement(ListItem, {
    role: "option"
  }, /*#__PURE__*/React.createElement(TextBase, {
    noWrap: true,
    color: "inherit"
  }, noOptionsMessage)), !!hasSubItems.length && multiple && hasSubItems.map(function (item) {
    var _item$subItems, _item$subItems2;

    return /*#__PURE__*/React.createElement("div", {
      key: item.value
    }, /*#__PURE__*/React.createElement("div", {
      className: cx('subtitle-block')
    }, /*#__PURE__*/React.createElement(TextBase, {
      color: "N100",
      size: "s",
      classes: {
        root: cx('subtitle')
      }
    }, ((_item$subItems = item.subItems) === null || _item$subItems === void 0 ? void 0 : _item$subItems.title) || item.label), /*#__PURE__*/React.createElement(Divider, null)), (_item$subItems2 = item.subItems) === null || _item$subItems2 === void 0 ? void 0 : _item$subItems2.options.map(function (subItem) {
      return /*#__PURE__*/React.createElement(DropListItem, {
        key: subItem.value,
        item: subItem,
        isSelected: isSelected(selected, subItem),
        icon: subItem.icon || icon,
        onClick: handleSelect(subItem),
        onKeyDown: handleKeyPress(subItem),
        classes: {
          mobileCheckIcon: cx('icon_check')
        }
      });
    }));
  })))));
});